var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-desc"},[_c('p',[_vm._v("课程介绍")]),_c('div',{staticClass:"course-desc-info",domProps:{"innerHTML":_vm._s(_vm.info.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }